import Tooltip from '@creditflowresearch/uilib/Tooltip';
import Button from '@creditflowresearch/uilib/Button';
import { Link } from '@framework/router/Next/Link';
import { useLinks } from './hooks/useLinks';

const Links = () => {
  const links = useLinks();

  return (
    <>
      { links.map(({ name, label, url, tooltip }) => {
        const button = (
          <Button
            key={ name }
            as={ Link }
            to={ url }
            variant="outline"
            size="S"
            fit={ { sm: 'full', md: 'full' } }
            dataTest={ `${ name }Link` }
          >
            { label }
          </Button>
        );

        if (tooltip) {
          return (
            <Tooltip key={ name } content={ tooltip } asChild>
              { button }
            </Tooltip>
          );
        }

        return button;
      }) }
    </>
  );
};

export default Links;
